import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { PipesModule } from "@app/_pipes/_pipes.module";
import { CoreDirectivesModule } from "@app/directives/_core/_core.directives.module";
import { LayoutDirectivesModule } from "@app/directives/_layout/_layout.directives.module";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MiscDirectivesModule } from "@app/directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { DriverScoreGraphComponent } from "@app/main/components/insights/driver-behaviour/driver-score-graph/driver-score-graph.component";
import { LiveMapModule } from "@app/main/components/livemap/livemap.module";
import { ReportsModule } from "@app/main/components/reports/reports.module";
import { providerCreator } from "@app/services/_services.module";
import { FilterOptionsService } from "@app/services/filterOptions.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { ChartWidgetComponent } from "./widgets/chart-widget/chart-widget.component";
import { ClockWidgetComponent } from "./widgets/clock-widget/clock-widget.component";
import { GaugeWidgetComponent } from "./widgets/gauge-widget/gauge-widget.component";
import { MetricWidgetComponent } from "./widgets/metric-widget/metric-widget.component";
import { VTableWidgetComponent } from "./widgets/table-widget/table-widget.component";
import { VTachoWarningsWidgetComponent } from "./widgets/tacho-warnings-widget/tacho-warnings-widget.component";
import { VVehicleUtilisationWidgetComponent } from "./widgets/vehicle-utilisation-widget/vehicle-utilisation-widget.component";
import { WidgetContainerComponent } from "./widgets/widget-container/widget-container.component";
import { GroupsModule } from "@app/main/components/resourceManagement/groups/groups.module";
import { VehicleDirectivesModule } from "@app/directives/_vehicle/_vehicle.directives.module";

const privateComponents: Type<any>[] = [

];

const publicComponents: any[] = [
    DashboardComponent,
    WidgetContainerComponent,
    MetricWidgetComponent,
    ChartWidgetComponent,
    DriverScoreGraphComponent,

    ClockWidgetComponent,
    GaugeWidgetComponent,
    VTableWidgetComponent,
    VVehicleUtilisationWidgetComponent,
    VTachoWarningsWidgetComponent
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    providerCreator(FilterOptionsService, "filterOptionsService"),
];

@NgModule({
    imports: [
        CommonModule,
        LayoutDirectivesModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        PipesModule,
        LiveMapModule,
        MiscDirectivesModule,
        CoreDirectivesModule,
        ReportsModule,
        GroupsModule,
        VehicleDirectivesModule,
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
})
export class DashboardModule {
    constructor() {
    }
}
